import { fork, takeLatest } from 'redux-saga/effects';

import { putAndWaitHandleAllAPIError } from '../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE,
    API_GET_APPLICATION,
    API_GET_ACCOUNTS
} from '../../api/lendingAPI/LendingAPI.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import { ACTIVATE_TERM_LOAN_DASHBOARD } from './Dashboard.actions';
import { activateMultiLoanDashboard } from '../multiLoanDashboard/Dashboard.sagas';

export const TERM_LOAN_URL = '/business-loan/';
export const TERM_LOAN_PAGE_NAME = 'TERM_LOAN_DASHBOARD';
export const TermLoanDashboardSagaWorkers = createWorkersForPage({
    page: TERM_LOAN_PAGE_NAME,
    isInPageLocation: (location) => location.pathname === TERM_LOAN_URL,
    createPageFlowWorkers: () => [fork(TermLoanDashboardPageWorker)]
});

function* TermLoanDashboardPageWorker() {
    yield takeLatest(ACTIVATE_TERM_LOAN_DASHBOARD, function* () {
        yield putAndWaitHandleAllAPIError([
            { type: API_GET_CUSTOMER_STATE },
            { type: API_GET_APPLICATION },
            { type: API_GET_ACCOUNTS }
        ]);

        return yield* activateMultiLoanDashboard();
    });
}
